import { QMS_CATEGORY_ERROR_MESSAGES } from '../../errors/errorMessages';

export const TAG_PATTERN = /^[A-Za-z0-9_-]+$/;
export const TAG_MAX_LENGTH = 30;
export const TAG_MAX_COUNT = 10;
export const INPUT_MAX_LENGTH = 255;

export interface ParseResult {
  added: string[];
  errors: string[];
}

export function parseAndValidateTags(
  rawInput: string,
  existingTags: string[]
): ParseResult {
  const parts = rawInput
    .split(',')
    .map((p) => p.trim())
    .filter((p) => p.length > 0);

  if (parts.length === 0) {
    return { added: [], errors: [QMS_CATEGORY_ERROR_MESSAGES.TAG_EMPTY] };
  }

  const added: string[] = [];
  const errors: string[] = [];
  const seenInBatch = new Set<string>();

  for (const part of parts) {
    const normalized = part.toLowerCase();

    if (part.length > TAG_MAX_LENGTH) {
      errors.push(
        `"${part.slice(0, 20)}…": ${QMS_CATEGORY_ERROR_MESSAGES.TAG_TOO_LONG}`
      );
      continue;
    }
    if (!TAG_PATTERN.test(part)) {
      errors.push(
        `"${part}": ${QMS_CATEGORY_ERROR_MESSAGES.TAG_INVALID_FORMAT}`
      );
      continue;
    }

    const isDuplicateExisting = existingTags.some(
      (t) => t.toLowerCase() === normalized
    );
    const isDuplicateInBatch = seenInBatch.has(normalized);

    if (isDuplicateExisting || isDuplicateInBatch) {
      errors.push(`"${part}": ${QMS_CATEGORY_ERROR_MESSAGES.TAG_DUPLICATE}`);
      continue;
    }

    seenInBatch.add(normalized);
    added.push(normalized);
  }

  return { added, errors };
}
